import Paper from "@material-ui/core/Paper";
import SubscriptionExpired from "Assets/Svg/subscription-expired.svg";
import React from "react";
import Grid from "@material-ui/core/Grid";
import { connect } from "react-redux";

class SubscriptionExpiredPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const { SubscriptionData } = this.props.SubscriptionInfo;
    //initial check if merchant's subscription and trialexpired is expired if not then push them back to login
    if (
      Object.keys(SubscriptionData) &&
      Object.keys(SubscriptionData).length > 0 &&
      (SubscriptionData.statusid === 4 || SubscriptionData.statusid === 7)
    ) {
      this.props.history.push("/trialexpired");
    } else if (
      Object.keys(SubscriptionData) &&
      Object.keys(SubscriptionData).length > 0 &&
      SubscriptionData.statusid === 1
    ) {
      this.props.history.push("/");
    }
  }

  render() {
    return (
      <Grid
        container
        style={{
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Grid item sm={12} md={4}>
          <Paper className="rounded-rectangle-paper padding24 text-center">
            <p
              className="large-text-dark-secondary t-bold margin-bottom-12"
              style={{ color: "#000", fontSize: 25 }}
            >
              Subscription expired!
            </p>
            <p
              className="small-dark-secondary  margin-bottom-24"
              style={{ color: "#000" }}
            >
              {/* sumHR plan expired on 09 Jan 2020 */}
              sumHR plan expired on{" "}
              {this.props.SubscriptionInfo &&
                this.props.SubscriptionInfo.SubscriptionData.expirydate}
            </p>
            <img src={SubscriptionExpired} className="margin-bottom-32"></img>
            <p
              className="normal-dark-secondary margin-bottom-12"
              style={{ color: "#000" }}
            >
              If you are an employee of{" "}
              {this.props.SubscriptionInfo &&
                this.props.SubscriptionInfo.SubscriptionData.subscriptionname}
              , please contact your HR team.
            </p>

            <div className="dashed-divider1"></div>

            <p
              className="normal-dark-secondary margin-bottom-12"
              style={{ color: "#000" }}
            >
              Account admins, please contact
            </p>
            <p
              className="normal-dark-secondary"
              style={{ color: "#1e8ced", fontSize: 19 }}
            >
              help@sumhr.com
            </p>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    SubscriptionInfo: state.SubscriptionInfo,
  };
}

export default connect(mapStateToProps, null)(SubscriptionExpiredPage);
